var sizeguidetabs = document.querySelectorAll("ul.sizeguide-tabs > li.tab");

sizeguidetabs.forEach(function (tab) {
  tab.addEventListener("click", function () {
    var tab_id = tab.getAttribute("data-tab");

    // Remove 'current' class from all tabs and tab contents
    var allTabs = document.querySelectorAll("ul.sizeguide-tabs > li");
    allTabs.forEach(function (item) {
      item.classList.remove("current");
    });

    var allTabContents = document.querySelectorAll(".sizeguide-tab-content");
    allTabContents.forEach(function (content) {
      content.classList.remove("current");
    });

    // Add 'current' class to the clicked tab and its corresponding content
    tab.classList.add("current");
    var tabContent = document.getElementById(tab_id);
    if (tabContent) {
      tabContent.classList.add("current");
    }
  });
});

var sizeSwitchers = document.querySelectorAll("a.size-toggle");

sizeSwitchers.forEach(function (sizeSwitcher) {
  sizeSwitcher.addEventListener("click", function () {
    var togglesAll = document.querySelectorAll(".size-toggle");

    togglesAll.forEach(function (element) {
      element.classList.remove("size-active");
    });

    this.classList.add("size-active");

    var size = sizeSwitcher.getAttribute("data-size");
    var sizeHeadersAll = document.querySelectorAll(".size-header");

    sizeHeadersAll.forEach(function (element) {
      element.classList.add("display-none");
    });

    var sizeHeadersToShow = document.querySelectorAll(`.size-${size}`);

    sizeHeadersToShow.forEach(function (element) {
      element.classList.remove("display-none");
    });
  });
});
